import { render } from "./App.vue?vue&type=template&id=e0d7c25c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e0d7c25c&lang=scss"

import exportComponent from "/Users/a86182/Desktop/明坤诚/sfa.itxiangtain.cn/sfa.itxiangtain.cn/sfa.admin.itxiangtain.cn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__